import { render, staticRenderFns } from "./not-found.vue?vue&type=template&id=6422ff5e&scoped=true&"
import script from "./not-found.vue?vue&type=script&lang=js&"
export * from "./not-found.vue?vue&type=script&lang=js&"
import style0 from "./not-found.vue?vue&type=style&index=0&id=6422ff5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6422ff5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6422ff5e')) {
      api.createRecord('6422ff5e', component.options)
    } else {
      api.reload('6422ff5e', component.options)
    }
    module.hot.accept("./not-found.vue?vue&type=template&id=6422ff5e&scoped=true&", function () {
      api.rerender('6422ff5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/not-found.vue"
export default component.exports